module.exports = __webpack_public_path__ + "img/04-01_Listening well.d8adbf53.svg";